export const createImageUrl = (url) => {
   return `${process.env.REACT_APP_BACKEND_URL}${url}`
}
